import React from 'react'
import _ from 'lodash'
import classNames from 'classnames'


const KEY_UP = 38
const KEY_DOWN = 40
const KEY_ENTER = 13
const KEY_ESCAPE = 27

export class AutoComplete extends React.Component {
    constructor(props) {
        super(props)

        this.state = this.defaultState()

        this.executeQuery = _.debounce(this.executeQuery, 300)
        this._isMounted = true
        this._placeholder = this.props.placeholder ? this.props.placeholder : ''
        this._cancelSearch = false // stop second search if user already selected something
        this._searchModel = this.props.type ? this.props.type : 'destinations'
        this._searchId  = this.props.searchId ? this.props.searchId : ''
        this._useCustomEntry = this.props.useCustomEntry

        _.bindAll(this,
            'onChangeQuery',
            'onKeyDown',
            'onMouseOver',
            'selectPrevious',
            'selectNext',
            'chooseSelection',
            'chooseCustomSelection',
            'close'
        )
    }

    defaultState() {
    // passing in query so we can leave value intact on select if desired
        let searchSabre = false
        let searchOpenCage = false
        this._cancelSearch = false

        if (this.props.onOpenCageQuery) {
            searchOpenCage = true
        }
        if (this.props.onSabreQuery) {
            searchSabre = true
        }

        return {
            query: '',
            selection: null,
            results: null,
            loading: false,
            error: null,
            opencage: searchOpenCage,
            sabre: searchSabre,
            moreLoading: false,
            value: '',
        }
    }

    componentDidMount() {
        this._isMounted = true
    }

    componentWillUnmount() {
        this._isMounted = false
    }

    componentWillReceiveProps(nextProps) {
    // one of the legs has changed, update the state
        if (this._placeholder !== nextProps.placeholder || this.state.customEntry !== nextProps.customEntry) {
            this._placeholder = nextProps.placeholder ? nextProps.placeholder : ''
            this.setState(this.defaultState())
            this._cancelSearch = true
        }
    }

    reset() {
        this.setState(this.defaultState())
    }

    onChangeQuery(evt) {
        let q = evt.target.value
        this.setState({
            query: q,
            value: q ? q : ''
        })

        this._cancelSearch = false

        if (q && q !== '') {
            this.executeQuery(q)
        } else {
            this.reset()
        }
    }

    onKeyDown(evt) {
        let keyHandlers = {}
        keyHandlers[KEY_UP] = this.selectPrevious
        keyHandlers[KEY_DOWN] = this.selectNext
        keyHandlers[KEY_ENTER] = this.chooseSelection
        keyHandlers[KEY_ESCAPE] = this.close

        var handler = _.get(keyHandlers, evt.which)

        if (handler) {
            evt.preventDefault()
            handler()
        }
    }

    onMouseOver(index) {
        this.setState({selection: index})
    }

    executeQuery(q) {
    // debounce can cause this to fire after we've cleared the field with backspace
        if (q === '') {
            this.reset()
            return false
        }

        this.setState({
            selection: null,
            results: null,
            loading: true,
            error: null
        })

        this.props.onExecuteQuery(q).then((results) => {
            // check if we're going to have to search opencage
            let openCage = false
            let sabre = false
            if (this.state.opencage && results.length < 10 ) {
                openCage = true
            }
            if (this.state.sabre && results.length < 10) {
                sabre = true
            }

            let newState = {
                results: results,
                loading: false,
                moreLoading: openCage || sabre
            }

            // select the first item
            if (results.length > 0) {
                newState.selection = 0
            }

            this.setState(newState)  

            // set up second query if we need it
            if (openCage) {
                this.props.onOpenCageQuery(q).then((results) => {
                    // exclude results that are already shown
                    results = _.filter(results, function(fr) {
                        let found = false
                        let match = _.filter(newState.results, function(sr) {
                            return sr.geohash == fr.geohash
                        })
                        if (match.length > 0) found = true
                        return !found
                    })

                    // expose some fields for display purposes
                    _.each(results, function(r, key) {            
                        let location = r.components[r.components._type]
                        let country = r.components['country']
                        let state = r.components['state']

                        if (location === undefined) {
                            r.name = _.split(r.formatted, ',', 1)[0] + ' "' + r.components._type + '" '
                        } else {
                            r.name = location
                        }
            
                        if (country == 'United States of America') {
                            // r.name += " ("+r.components["state"]+")"
                            r.state = r.components['state']
                        } else {
                            // r.name += " ("+r.components["country"]+")"              
                            r.state = r.components['country']
                        }
                        r.type = 'opencage'
                        // r.name = r.components[r.components._type] + " ("+r.components["state"]+", "+r.components["country"]+")",
                    })                    
                    if (this._isMounted && !this._cancelSearch) {
                        console.log('Second Results: ' + this._cancelSearch)
                        this.setState({
                            results: newState.results.concat(results),
                            moreLoading: false
                        })
                    }
                }).catch((error) => {   
                    console.log('an error?')
                    console.log(error)
                    this.setState({
                        loading: false,
                        error: 'There was an error searching for more results',
                        results: [],
                        moreLoading: false
                    })
                })
            }
        }).catch((error) => {
            console.log('an error (second catch)?')
            console.log(error)
            this.setState({
                loading: false,
                error: 'There was an error executing your search query',
                results: [],
            })
        })
    }

    selectPrevious() {
        this.setState({
            selection: _.max([0, this.state.selection - 1])
        })
    }

    selectNext() {
        this.setState({
            selection: _.min([this.state.results.length - 1, this.state.selection + 1])
        })
    }

    chooseSelection() {    
        let choice = this.state.results[this.state.selection]
        this.props.onChoose(choice)
        this.close(choice.name)
        this._cancelSearch = true
    }

    chooseCustomSelection() {    
    // console.log('set it')
        let choice = this.state.query
        this.props.onChoose(choice)
        this.close(choice)
        this._cancelSearch = true
    }

    close(value) {
        this.setState(this.defaultState())
        this.setState({value: value})
        this._cancelSearch = true
    }

    render() {
        let renderResults = () => {
            if (!this.state.results || this.state.results.length === 0) {
                return null
            }

            let results = _.map(this.state.results, (result, i) => {
                let classes = classNames('result', {
                    selected: this.state.selection === i
                })

                let mouseOver = (index) => {
                    return (evt) => {
                        this.onMouseOver(index)
                    }
                }

                return (
                    <li
            key={i}
            className={ classes }
            onMouseOver={ mouseOver(i) }
            onClick={ this.chooseSelection }>
                        { this.props.onRenderResult(result) }
                    </li>
                )
            })      

            return results
        }

        let renderCustomEntry = () => {
            if (this.state.query !== '') {
                // duplicate regular result behavior
                let classes = classNames('result', {
                    selected: this.state.selection === 0
                })

                let mouseOver = (index) => {
                    return (evt) => {
                        this.onMouseOver(index)
                    }
                }

                return (
                    <li
              key="custom-entry"
              className={ classes }
              onMouseOver={ mouseOver(0) }
              onClick={ this.chooseCustomSelection }>
              Use "{ this.state.query }"
                    </li>
                )
            }
        }

        let renderError = () => {
            return <li key="-4" className="result no-select">{this.state.error}</li>
        }

        let renderNoResults = () => {      
            return <li key="-3" className="result no-select">No Results</li>
        }

        let renderLoading = () => {
            return <li key="-2" className="result no-select">Loading...</li>
        }

        let renderMoreLoading = () => {
            return <li key="-1" className="result no-select">Searching for more...</li>
        }

        let results = null
        if (this.state.loading) {
            results = renderLoading()
        } else if (this.state.error) {
            results = renderError()
        } else if (this.state.results && this.state.results.length === 0) {
            if (this.props.hideEmpty) {
                results = null
            } else {
                results = renderNoResults()
            }
        } else if (this.state.results && this.state.results.length > 0) {
            results = renderResults()
        }

        if (this.state.moreLoading) {
            let showMore = renderMoreLoading()
            results = [results, showMore]
        }

        // double check the field still has a value, if not clear all but custom
        if (this.state.query === '') {
            results = null
        }

        if (this._useCustomEntry) {
            let myEntry = renderCustomEntry()
            results = [myEntry, results]
        }

        if (results) {
            results = <ul className="results">{results}</ul>
        }

        let searchClass = classNames(
            'autocomplete',
            this.props.searchClass
        ) 

        let formID = 'search-' + this._searchModel + this._searchId

        return (
            <div className={searchClass}>
                <div className="form-group input-plain">
                    <i className="icon-search" aria-hidden="true"/>
                    <input
            id={formID}
            name={formID}
            type="search"
            className="form-control search input-medium"
            placeholder={ this._placeholder }
            value={this.state.value ? this.state.value : this.state.query }
            onChange={this.onChangeQuery}
            onKeyDown={this.onKeyDown}/>
                </div>
                {results}
            </div>
        )
    }
}

AutoComplete.propTypes = {
    onExecuteQuery: React.PropTypes.func.isRequired,
    onRenderResult: React.PropTypes.func,
    onChoose: React.PropTypes.func.isRequired,
}

AutoComplete.defaultProps = {
    onRenderResult: _.identity,
}